import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUser,
  faRightFromBracket,
  faBars,
  faXmark,
  faBuilding,
  faMoneyBill,
  faCalendarDays,
} from '@fortawesome/free-solid-svg-icons';
import './DashboardNav.css';
import AdminClubManager from './AdminClubManager';
import AdminEvents from '../components/AdminEvents';
import AdminFees from './AdminFees';
import CCHEventsList from './CCHEventsList';
import AdminProfile from './AdminProfile';

function AdminDashboard() {
  const [admin, setAdmin] = useState(null);
  const [message, setMessage] = useState('');
  const [activeTab, setActiveTab] = useState('clubs');
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    if (!token) {
      navigate('/admin/login');
      return;
    }

    fetch('https://www.fro.ro/api/admins/protected-admin.php', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setAdmin(data.admin);
        } else {
          setMessage('Acces neautorizat. Relogare necesară.');
          localStorage.removeItem('adminToken');
          navigate('/admin/login');
        }
      })
      .catch(() => {
        setMessage('Eroare la server.');
      });
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    navigate('/admin/login');
  };

  if (message) return <p>{message}</p>;
  if (!admin) return <p>Se încarcă...</p>;

  return (
    <div className="dashboard-gradient-bg">
      <div className="dashboard-header">
        <h1 className="dashboard-title">Admin Panel</h1>

        {/* Buton meniu mobil */}
        <button
          className="dashboard-menu-btn"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <FontAwesomeIcon icon={menuOpen ? faXmark : faBars} size="2x" />
        </button>

        {/* NAV Desktop */}
        <div className="dashboard-user-info desktop-only">
          <nav className="dashboard-nav">
            <button
              className={`dashboard-nav-btn${activeTab === 'cch' ? ' active' : ''}`}
              onClick={() => setActiveTab('cch')}
            >
              <FontAwesomeIcon icon={faCalendarDays} /> CCH
            </button>

            <button
              className={`dashboard-nav-btn${activeTab === 'events' ? ' active' : ''}`}
              onClick={() => setActiveTab('events')}
            >
              <FontAwesomeIcon icon={faCalendarDays} /> Evenimente
            </button>
            <button
              className={`dashboard-nav-btn${activeTab === 'clubs' ? ' active' : ''}`}
              onClick={() => setActiveTab('clubs')}
            >
              <FontAwesomeIcon icon={faBuilding} /> Cluburi
            </button>
            <button
              className={`dashboard-nav-btn${activeTab === 'taxes' ? ' active' : ''}`}
              onClick={() => setActiveTab('taxes')}
            >
              <FontAwesomeIcon icon={faMoneyBill} /> Taxe
            </button>
          </nav>

          <div className="dashboard-actions">
             <button
  className={`dashboard-profile-btn${activeTab === 'profile' ? ' active' : ''}`}
  title="Profil"
  onClick={() => setActiveTab('profile')}
>
  <FontAwesomeIcon icon={faUser} size="2x" color="#222" />
</button>

            <button
              className="dashboard-logout-btn"
              onClick={handleLogout}
              title="Logout"
            >
              <FontAwesomeIcon icon={faRightFromBracket} size="lg" color="#222" />
              Log-out
            </button>
          </div>
        </div>
      </div>

      {/* Meniu mobil off-canvas */}
      <div className={`mobile-menu ${menuOpen ? 'open' : ''}`}>
        <nav className="mobile-nav">
          <button
            onClick={() => {
              setActiveTab('cch');
              setMenuOpen(false);
            }}
          >
            <FontAwesomeIcon icon={faCalendarDays} /> CCH
          </button>
          <button
            onClick={() => {
              setActiveTab('events');
              setMenuOpen(false);
            }}
          >
            <FontAwesomeIcon icon={faCalendarDays} /> Evenimente
          </button>
          <button
            onClick={() => {
              setActiveTab('clubs');
              setMenuOpen(false);
            }}
          >
            <FontAwesomeIcon icon={faBuilding} /> Cluburi
          </button>
          <button
            onClick={() => {
              setActiveTab('taxes');
              setMenuOpen(false);
            }}
          >
            <FontAwesomeIcon icon={faMoneyBill} /> Taxe
          </button>

        </nav>

        <hr className="mobile-divider" />

        <div className="mobile-actions">
         <button
  onClick={() => {
    setActiveTab('profile');
    setMenuOpen(false);
  }}
>
  <FontAwesomeIcon icon={faUser} /> Profil
</button>

          <button onClick={handleLogout}>
            <FontAwesomeIcon icon={faRightFromBracket} /> Logout
          </button>
        </div>
      </div>

      {/* Conținut taburi */}
      <div className={`dashboard-stats-elements ${activeTab === 'events' ? 'no-bg' : ''}`}>
        {activeTab !== 'events' && (
          <h2 className="dashboard-stat-title">
          
          </h2>
        )}
        {activeTab === 'cch' && <CCHEventsList />}

        {activeTab === 'events' && <AdminEvents />}
        {activeTab === 'clubs' && <AdminClubManager />}
        {activeTab === 'taxes' && <AdminFees />}
        {activeTab === 'profile' && <AdminProfile />}

      </div>
    </div>
  );
}

export default AdminDashboard;
